import React from "react";
import { v4 as uuid } from "uuid";
import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import StyledTooltip from "../Wrapper/StyledTooltip";

export interface WhiteChip {
  label?: string;
  value?: string;
  unitCode?: string;
}

export interface WhiteChipTooltipProps {
  children: React.ReactElement;
  header?: string;
  values: WhiteChip[];
}

const useStyles = makeStyles({
  noContent: {
    fontStyle: "italic",
  },
  title: {
    fontWeight: "bold",
  },
});

const WhiteChipTooltip: React.FC<WhiteChipTooltipProps> = (props) => {
  const { children, header, values } = props;
  const classes = useStyles();

  const relevantValues = values.filter((whiteChip) => whiteChip.label || whiteChip.value || whiteChip.unitCode);

  return (
    <StyledTooltip
      title={
        <>
          <Box fontWeight="bold">{header}</Box>
          {relevantValues.length > 0 ? (
            <>
              {relevantValues.map((whiteChip: WhiteChip) => {
                return (
                  <div key={uuid()}>
                    {whiteChip.label ? `${whiteChip.label}: ` : ""}
                    {whiteChip.value} {whiteChip.unitCode || ""}
                  </div>
                );
              })}
            </>
          ) : (
            <div className={classes.noContent}>No parameter</div>
          )}
        </>
      }
    >
      <Box component="span">{children}</Box>
    </StyledTooltip>
  );
};

export default WhiteChipTooltip;
